import { render } from "./PrivacyAndTerms.vue?vue&type=template&id=41629d60&scoped=true"
import script from "./PrivacyAndTerms.vue?vue&type=script&lang=js"
export * from "./PrivacyAndTerms.vue?vue&type=script&lang=js"

import "./PrivacyAndTerms.vue?vue&type=style&index=0&id=41629d60&scoped=true&lang=scss"
import "./PrivacyAndTerms.vue?vue&type=style&index=1&id=41629d60&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41629d60"]])

export default __exports__